import { motion } from 'framer-motion';
import '../../styles/components/sidebar/sidebarProfileTheme2.scss';
import CustomSVGs from '../../ui/customSVGs/CustomSVGs';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import {
  creditCardSVG,
  logoutSVG,
  questionSVG,
  settingsPlusSVG,
} from '../../lib/allCustomSVGs';
import { signOutOfApp } from '../../lib/api/sign-out';
import { useNavigate } from 'react-router-dom';
import { useCan } from '../../lib/rbac';
import { usePlanLock } from '../../lib/plan-lock/usePlanLock';

type Props = {
  isProfileLinkHidden?: boolean;
  isSettingsLinkHidden?: boolean;
};

const SidebarProfileTheme2 = ({
  isProfileLinkHidden,
  isSettingsLinkHidden,
}: Props) => {
  const { t } = useTranslation();
  const appTheme = useSelector((state: RootState) => state.UI.theme.dark);
  const taraSubscriptionDetails = useSelector(
    (state: RootState) => state.user?.shop?.taraSubscriptionDetails
  );
  const navigate = useNavigate();
  const canViewBilling = useCan('billing.view');
  // No active plan or trial: Settings (a product area) leaves the menu;
  // Subscription, Support and Sign Out stay.
  const { locked: isPlanLocked } = usePlanLock();

  const logoutHandler = () => {
    const next = signOutOfApp();
    if (next) {
      navigate(next);
    }
  };

  return (
    <motion.ul
      className='sidebarProfileTheme2'
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
    >
      {/* Opens the plans page on its own path, for roles that may see billing. */}
      {!isProfileLinkHidden &&
      canViewBilling &&
      (!taraSubscriptionDetails ||
        taraSubscriptionDetails?.currentSubscriptionStatus === 'none') ? (
        <li
          onClick={() => {
            navigate('/settings/subscription');
          }}
        >
          <CustomSVGs svg={creditCardSVG} />
          <span>{t('PricingPlans')}</span>
        </li>
      ) : null}

      {!isProfileLinkHidden &&
      taraSubscriptionDetails &&
      taraSubscriptionDetails?.currentSubscriptionStatus === 'active' ? (
        <li
          onClick={() => {
            navigate('/settings/subscription');
          }}
        >
          <CustomSVGs svg={creditCardSVG} />
          <span>{t('Subscription')}</span>
        </li>
      ) : null}

      {/* {!isProfileLinkHidden ? (
        <li
          onClick={() => {
            navigate('/settings/general');
          }}
        >
          <CustomSVGs svg={userSVG} />
          <span>{t('EditProfile')}</span>
        </li>
      ) : null} */}

      {!isSettingsLinkHidden && !isPlanLocked ? (
        <li
          onClick={() => {
            navigate('/settings');
          }}
        >
          <CustomSVGs svg={settingsPlusSVG} />
          <span>{t('Settings')}</span>
        </li>
      ) : null}

      {/* <li
        onClick={() => {
          dispatch(setAppThemeMode());
        }}
      >
        {appTheme ? <CustomSVGs svg={sunSVG} /> : <CustomSVGs svg={moonSVG} />}
        {!appTheme && <span>{t('DarkMode')}</span>}
        {appTheme && <span>{t('LightMode')}</span>}
      </li> */}
      <li
        onClick={() => {
          window.open('https://intercom.help/ad-up/en', '_blank');
        }}
      >
        <CustomSVGs svg={questionSVG} />
        <span>{t('Support')}</span>
      </li>
      <li onClick={logoutHandler}>
        <CustomSVGs svg={logoutSVG} />
        <span>{t('Logout')}</span>
      </li>
    </motion.ul>
  );
};

export default SidebarProfileTheme2;
